<div>
  <form [formGroup]="form">
    <div class="fields-container">
      <div class="field-control">
        <app-text-field
          [type]="'big-text'"
          [label]="'INFO_SERVICE.KIND_OF_GOODS' | translate"
          [control]="form.get('kindOfGoods')!"
          [maxlength]="100"
        ></app-text-field>
      </div>
      <div class="field-control">
        <app-searchable-list
          [label]="'PRODUCT_FORM.COO_PRODUCT_HS_CODE' | translate"
          [placeholder]="'PRODUCT_FORM.SEARCH_PH' | translate"
          [options]="hsCodeList"
          [control]="form.get('productHSCode')!"
          (onAdd)="onAddItem($event)"
          [loading]="loadingHsCode"
          [noOfTotalRecords]="totalHsRecords"
          [noOfRecordPerPage]="50"
          (onRemove)="onRemoveItem($event)"
          (onPageChange)="fetchNextRecord($event)"
          (search)="handleSearch($event)"
          [showSelectedItemsList]="false"
          [allowAddMultiple]="false"
          [showPageNation]="true"
          (onSelectionClear)="clearHsCode()"
        />
        <!-- @if(form.get('productHSCode')?.value){
        <div class="mt-2 text-dc-navy font-semibold">
          {{ "PRODUCT_FORM.COO_PRODUCT_HS_CODE" | translate }}:
          {{ form.get("productHSCode")?.value }}
        </div>
        } -->
      </div>
      <!-- Manufacturing Country (Dropdown) -->
      <div class="field-control">
        <app-option-field
          [country]="true"
          [label]="'INFO_SERVICE.COUNTRY_OF_ORIGIN' | translate"
          [lovType]="lookupKey.COUNTRY"
          [control]="form.get('countryOfOrigin')!"
          [labelKey]="'Value'"
          [valueKey]="'Value'"
        ></app-option-field>
      </div>

      <!-- actions -->
      <div class="buttons-group">
        @if(!isEditMode){
        <app-button
          classesName="btn-edge-cut btn-width-auto"
          [label]="'BUTTONS.ADD' | translate"
          (onBtnClick)="add()"
        ></app-button>
        }
      </div>

      @if(!isEditMode && addedProducts.length > 0){
      <div class="product-table-wrapper mt-4">
        <table class="product-table">
          <thead>
            <tr>
              <th class="w-1/2">
                {{ "INFO_SERVICE.KIND_OF_GOODS" | translate }}
              </th>
              <th class="w-1/4">
                {{ "PRODUCT_FORM.COO_PRODUCT_HS_CODE" | translate }}
              </th>
              <th class="w-1/4">
                {{ "INFO_SERVICE.COUNTRY_OF_ORIGIN" | translate }}
              </th>
              <th class="w-[10%]"></th>
            </tr>
          </thead>
          <tbody>
            @for (row of addedProducts; track row.id) {
            <tr>
              <td [attr.data-label]="'INFO_SERVICE.KIND_OF_GOODS' | translate">
                {{ row.kindOfGoods }}
              </td>
              <td [attr.data-label]="'PRODUCT_FORM.COO_PRODUCT_HS_CODE' | translate">
                {{ row.productHSCode }}
              </td>
              <td [attr.data-label]="'INFO_SERVICE.COUNTRY_OF_ORIGIN' | translate">
                {{ row.countryOfOrigin?.Value ?? row.countryOfOrigin }}
              </td>
              <td [attr.data-label]="'Actions'">
                <button
                  class="text-dc-navy font-semibold"
                  type="button"
                  (click)="removeProduct(row)"
                >
                  <i class="fa-solid fa-xmark"></i>
                </button>
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
      }

      <div class="buttons-group mt-4">
        <app-button
          classesName="btn-edge-cut btn-width-auto"
          [label]="'BUTTONS.SAVE_CLOSE' | translate"
          (onBtnClick)="saveAndClose()"
        ></app-button>
        <app-button
          classesName="card-edge-cut-white btn-width-auto"
          [label]="'BUTTONS.CANCEL' | translate"
          (onBtnClick)="close()"
        ></app-button>
      </div>
    </div>
  </form>
</div>
